import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from "../../labels/interviewProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getExamslistByAdvertisementId,
  getObjectiveStatus,
  getObjectiveStatusflag,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getMainsAdvertisements,
  getYearList,
} from "../../../common/actions/commonActions";
import {
  SeatMatrixLockUnlock,
  getinterviewQualification,
  getrecommendationReports,
} from "../../actions/interviewProcessActions";
import { GET_INTERVIEW_QUALIFIED_CANDIDATE, SET_OBJECTIVE_STATUS_DATA_FLAG } from "../../../common/constants/ActionTypes";
const GenerateInterviewQualifiedCandidate = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    setFlagArray([]);
    dispatch({
      payload: [],
      type: GET_INTERVIEW_QUALIFIED_CANDIDATE,
    });
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA_FLAG
    })
    setReloadItem(!reloadItem);
  }, []);
  let { examList, objectiveStatusData, objectiveStatusDataFlag } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let { getinterviewqualifiedCandidate } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  const dispatch = useDispatch();
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [onCalculate, setCalculate] = useState(false);
  const [reloadItem, setReloadItem] = useState(true);
  const [lockdisable, setLockdisable] = useState(true);
  const [view, setView] = useState(false);
  const [unLock, setUnlock] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [flagArray, setFlagArray] = useState([]);

  useEffect(() => {
    setFlagArray([]);
    if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
      const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
      const flagArrayBeforeInterviewCriteria = [];

      for (let i = 0; i < flagValues.length; i++) {
        if (flagValues[i] === "Interview Qualification") {
          setFlagArray(flagArrayBeforeInterviewCriteria);
          break;
        } else {
          if (objectiveStatusDataFlag[i]?.flagStatus) {
            flagArrayBeforeInterviewCriteria.push(
              objectiveStatusDataFlag[i]
            );
          }
        }
      }
    }
  }, [objectiveStatusDataFlag]);

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    setFlagArray([]);
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }

    setSaveButtonFlag(true);
    dispatch({
      payload: [],
      type: GET_INTERVIEW_QUALIFIED_CANDIDATE,
    });
    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setFlagArray([]);
    setSelectedAdvert(selectedValue);
    setSelectedExam("");
    examList.length = 0;

    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
    dispatch({
      payload: [],
      type: GET_INTERVIEW_QUALIFIED_CANDIDATE,
    });
  };
  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);

    Promise.resolve()
      .then(() => {

        if (selectedValue) {
          return dispatch(getObjectiveStatus(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        if (selectedValue) {
          return dispatch(getObjectiveStatusflag(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        setReloadItem((prev) => !prev);


        return dispatch({
          payload: [],
          type: GET_INTERVIEW_QUALIFIED_CANDIDATE,
        });
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };

  const onCalculateCandidate = (type) => {
    setUnlock(true)
    dispatch(getinterviewQualification(selectedExam, type));
  };
  const onViewCandidate = (type) => {
    setUnlock(false)
    dispatch(getrecommendationReports(selectedExam, type));
  };

  // const onLockCandidate = () => {
  //   setUnlock(true)
  //   dispatch(
  //     SeatMatrixLockUnlock(selectedExam, "interviewqualification", "true")
  //   );
  //   dispatch({
  //     payload: [],
  //     type: GET_INTERVIEW_QUALIFIED_CANDIDATE,
  //   });
  // };
  // const onUnLockCandidate = () => {
  //   dispatch(
  //     SeatMatrixLockUnlock(selectedExam, "interviewqualification", "false")
  //   );
  //   dispatch({
  //     payload: [],
  //     type: GET_INTERVIEW_QUALIFIED_CANDIDATE,
  //   });
  // };
  const onLockCandidate = async () => {
    setUnlock(true);

    await dispatch(
      SeatMatrixLockUnlock(
        selectedExam,
        "interviewqualification",
        "true"
      )
    );

    dispatch(getObjectiveStatus(selectedExam));
    dispatch(getObjectiveStatusflag(selectedExam));
  };

  const onUnLockCandidate = async () => {
    await dispatch(
      SeatMatrixLockUnlock(
        selectedExam,
        "interviewqualification",
        "false"
      )
    );

    dispatch(getObjectiveStatus(selectedExam));
    dispatch(getObjectiveStatusflag(selectedExam));
  };
  return (
    <div className="dashboardContentArea">
      <h5> {label.ProvisionalMeritList} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                        // <option key={index} value={element.id}>
                        //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                        // </option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getMainsAdvertisement &&
                      getMainsAdvertisement.length > 0 &&
                      getMainsAdvertisement
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-4">
                  <label className="float-left">
                    {commonLabels.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>


              </div>


              <div className="row pl-3 pr-3">
                {flagArray &&
                  flagArray.length > 0 &&
                  flagArray.map((ele, index) => (
                    <div className="d-flex p-2" key={index}>
                      <input
                        type="checkbox"
                        disabled
                        checked={ele.flagStatus === true && true}
                        className="form-control"
                      />
                      <label className="ml-1">{ele.flag}</label>
                    </div>
                  ))}
              </div>



              <div className="row">
                <div className="col-md-12">
                  {(objectiveStatusData.flgInterviewQualificationLocked ==
                    false || objectiveStatusData.flgInterviewQualificationLocked == null) && (
                      <button
                        type="button"
                        className="btn btn-primary mb-2"
                        disabled={onCalculate}
                        onClick={() => {
                          onCalculateCandidate("interviewCriteria");
                        }}
                      >
                        {commonLabels.CalculateCandidate}
                      </button>
                    )}

                  {selectedExam && objectiveStatusData.flgIsInterviewQualificationGenerated !==
                    null && (
                      <button
                        type="button"
                        className="btn btn-primary ml-2 mb-2"
                        onClick={() => {
                          onViewCandidate("interviewcandidates");
                        }}
                      >
                        {commonLabels.View}
                      </button>
                    )}
                  {selectedExam && objectiveStatusData.flgInterviewQualificationLocked ==
                    false && (
                      <button
                        type="button"
                        className="btn btn-primary ml-2 mb-2"
                        onClick={() => {
                          onLockCandidate();
                        }}
                      >
                        {commonLabels.Lock}
                      </button>
                    )}

                  {selectedExam && objectiveStatusData.flgInterviewQualificationLocked ==
                    true && (
                      <button
                        type="button"
                        className="btn btn-primary ml-2 mb-2"
                        disabled={unLock}
                        onClick={() => {
                          onUnLockCandidate();
                        }}
                      >
                        {commonLabels.Unlock}
                      </button>
                    )}
                  {/* {selectedExam && (
                    <button
                      type="button"
                      className={`btn ml-2 mb-2 ${objectiveStatusData.flgInterviewQualificationLocked
                          ? "btn-lock-green"
                          : "btn-unlock-red"
                        }`}
                      disabled={
                        objectiveStatusData.flgInterviewQualificationLocked
                          ? commonLabels.Unlock
                          :commonLabels.Lock
                      }
                      onClick={() => {
                        objectiveStatusData.flgInterviewQualificationLocked
                          ? onUnLockCandidate()
                          : onLockCandidate();
                      }}
                    >
                      {objectiveStatusData.flgInterviewQualificationLocked
                        ? commonLabels.Unlock
                        : commonLabels.Lock}
                    </button>
                  )} */}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {getinterviewqualifiedCandidate &&
        getinterviewqualifiedCandidate.qualifiedCandidates &&
        getinterviewqualifiedCandidate.qualifiedCandidates.length > 0 && (
          <div ref={pdfRef} id="">
            <div className="row ">
              <div className="table-responsive answerKeyTable  col-md-12">
                <table className="table text-left">
                  <thead className="">
                    <tr>
                      <th className="p-3 text-center" scope="col w-5">
                        {label.SNo}
                      </th>
                      <th className="p-3 text-center" scope="col w-5">
                        {label.IntNo}
                      </th>
                      <th className="p-3 text-center" scope="col w-5">
                        {label.RollNO}
                      </th>
                      <th className="p-3 text-center" scope="col w-5">
                       Application No
                      </th>
                      <th className="p-3 text-left" scope="col w-5">
                        {label.Category}
                      </th>
                      <th className="p-3 text-left" scope="col w-5">
                        {label.SubCategory}
                      </th>
                      <th className="p-3 text-center" scope="col w-5">
                        {label.Gender}
                      </th>
                      <th className="p-3 text-center" scope="col w-5">
                        {label.PostCriterias}
                            </th>
                      <th className="p-3 text-left" scope="col w-30">
                        {label.CandidateName}
                      </th>
                      <th className="p-3 text-center" scope="col w-5">
                        {label.Status}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tbody-style">
                    {getinterviewqualifiedCandidate &&
                      getinterviewqualifiedCandidate.qualifiedCandidates &&
                      getinterviewqualifiedCandidate.qualifiedCandidates
                        .length > 0 &&
                      getinterviewqualifiedCandidate.qualifiedCandidates.map(
                        (ele, ind) => {
                          return (
                            <tr key={ind}>
                              <td className="text-center">{ind + 1}</td>
                              <td className="text-center">{ele.interviewNo}</td>
                              <td className="text-center">{ele.rollNo}</td>
                              <td className="text-center">{ele.applicationId}</td>
                              <td className="text-left">{ele.category}</td>
                              <td className="text-left">{ele.subCategory}</td>
                              <td className="text-center">{ele.gender}</td>
                              <td className="text-center">{ele.postCriteriaName}</td>
                              <td className="text-left">{ele.candidateName}</td>
                              <td className="text-center">{ele.status}</td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default GenerateInterviewQualifiedCandidate;
